import { type ReactNode } from "react";
import { useLocation } from "react-router";

import { RouteProtectionWrapper } from "@vega-api/extended/auth/RouteProtectionWrapper";
import { CommonPaths } from "@vega-modules/paths";

export const PermissionsRouteGuard = ({
  children,
  fallbackPath = CommonPaths.Home,
}: {
  children: ReactNode;
  fallbackPath?: string;
}) => {
  const location = useLocation();

  if (
    [
      CommonPaths.Login,
      CommonPaths.NotFound,
      CommonPaths.OktaAuth,
      CommonPaths.SelectOrg,
      CommonPaths.Welcome,
    ].includes(location.pathname as CommonPaths & string)
  ) {
    return children;
  }

  return (
    <RouteProtectionWrapper fallbackPath={fallbackPath}>
      {children}
    </RouteProtectionWrapper>
  );
};
